import { LoadingButton } from '@mui/lab'
import { Dialog, DialogActions, DialogTitle, DialogContent, Box, Typography, useMediaQuery, Divider } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useReOrderCancelShipmentMutation } from 'src/_api/mapitShipApi'

export default function ReorderCancelledShipmentDialog({
    open,
    onClose,
    orderId
}) {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const fullScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'))


    const onCloseHandler = () => {
        onClose()
    }

    const [reorderCancelledShipment, { isLoading, error, isSuccess }] = useReOrderCancelShipmentMutation()

    const handleReorder = async () => {
        try {

            await reorderCancelledShipment({ orderId })
            setTimeout(() => {
                onCloseHandler()
                navigate("/merchant/mapit-ship/shipments?page=1&limit=100&status=ORDER_PENDING")
            }, 2000)

        } catch (error) {
            console.error('Error reordering cancelled shipment:', error)
        }
    }
    return (
        <Dialog
            open={open}
            onClose={(e) => e.preventDefault()}
            fullScreen={fullScreen}
            fullWidth
        >
            <DialogTitle>{t('Reorder')}</DialogTitle>
            <Divider />
            <DialogContent>
                <Typography>
                    {t("The order will be duplicated with same data and with a new order number in (Order created).")}
                </Typography>
            </DialogContent>
            <Divider />
            <DialogActions>
                {isSuccess && <Typography color="success.main">{t("Done successfully")}</Typography>}
                {!!error && <Typography color="error">{error}</Typography>}
                <Box mr="auto" />
                <LoadingButton
                    loading={isLoading}
                    variant="contained"
                    color="primary"
                    sx={{ textTransform: 'none' }}
                    onClick={onCloseHandler}
                >
                    {t('Cancel')}
                </LoadingButton>
                <LoadingButton
                    loading={isLoading}
                    variant="contained"
                    color="primary"
                    sx={{ textTransform: 'none' }}
                    onClick={handleReorder}
                >
                    {t('Reorder')}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}
